export default "__VITE_ASSET__ZR2gtIxI__"